import * as React from 'react';
import { Box, Image } from '@wix/design-system';
import s from './ProductFeatureIcon.scss';
import classNames from 'classnames';
const IMAGE_DIMENSION = '18px';
export function FeatureIcon({ iconUrl, marginLeft, marginRight, disabled = false, }) {
    return iconUrl ? (React.createElement(Box, { inline: true, className: classNames(s.container, { [s.disabled]: disabled }), marginLeft: marginLeft, marginRight: marginRight },
        React.createElement(Image, { transparent: true, fit: "contain", src: iconUrl, height: IMAGE_DIMENSION, width: IMAGE_DIMENSION }))) : null;
}
//# sourceMappingURL=ProductFeatureIcon.js.map